module.exports = __webpack_public_path__ + "img/audio.2a275840.svg";